<template>
  <div class="contact">
    <Header />
    <h2>Kontakt</h2>
    <div class="box">
      <h3>Kontakt</h3>
      <p>
        <span>Email:</span>
        <span>
          <a href="mailto:kontakt@janeiroforlag.se">kontakt@janeiroforlag.se</a>
        </span>
      </p>
      <p>
        <span>Adress:</span>
        <span>Mailbox 1602, 411 37 Göteborg</span>
      </p>
    </div>
    <div class="box">
      <h3>Manus</h3>
      <p>
        <s>
          Vi är måna om att vara ett bokförlag som ger ut poesi och lyrik av
          absolut högsta klass. Således tar vi enbart emot fullständiga och väl
          genomarbetade manus. Vänligen skicka in ert manus till
          <a href="mailto:manus@janeiroforlag.se">manus@janeiroforlag.se</a>
          .
        </s>
      </p>
      <p>
        <b>Vi har för tillfället manusstopp!</b>
      </p>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Vue from "vue";

export default Vue.extend({
  name: "contact",
  components: {
    Header,
    Footer,
  },
});
</script>

<style lang="scss" scoped>
.contact {
  h2 {
    margin: 20px 0;
    text-align: center;
  }
}
.box {
  margin-bottom: 20px;
  h3 {
    margin-bottom: 12px;
  }
  img {
    width: 100%;
    max-width: 600px;
    margin-bottom: 24px;
  }
  p {
    margin-bottom: 12px;
    span:first-child {
      margin-right: 16px;
    }
  }
  i {
    font-style: italic;
  }
}
</style>
